var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { createURLDescriptor, joinPaths } from './URLTools';
import { reduceStatuses } from './Resolver';
import { SegmentType, createSegment } from './Segments';
import { NodeMatcher, NaviNodeType } from './Node';
var emptyObject = {};

var RedirectMatcher =
/** @class */
function (_super) {
  __extends(RedirectMatcher, _super);

  function RedirectMatcher() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  RedirectMatcher.prototype.execute = function () {
    var toResolution = this.resolver.resolve(this.env, this.constructor.to);
    var to = toResolution.value,
        status = toResolution.status,
        error = toResolution.error;
    var metaResolution = this.resolver.resolve(this.env, this.constructor.meta);
    var meta = metaResolution.value;
    status = reduceStatuses(status, metaResolution.status);
    error = error || metaResolution.error; // TODO: support all relative URLs

    var toHref;

    if (typeof to === 'string') {
      if (to.slice(0, 2) === './') {
        toHref = joinPaths(this.env.pathname.split('/').slice(0, -1).join('/'), to.slice(2));
      } else {
        toHref = to;
      }
    } else if (to) {
      toHref = createURLDescriptor(to).href;
    }

    return {
      resolutionIds: [toResolution.id, metaResolution.id],
      segment: createSegment(SegmentType.Redirect, this.env, {
        to: toHref,
        meta: meta || emptyObject,
        status: status,
        error: error,
        remainingSegments: []
      })
    };
  };

  RedirectMatcher.isNode = true;
  RedirectMatcher.type = NaviNodeType.Redirect;
  return RedirectMatcher;
}(NodeMatcher);

export { RedirectMatcher };
export function createRedirect(to, meta) {
  var _a;

  return _a =
  /** @class */
  function (_super) {
    __extends(class_1, _super);

    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    return class_1;
  }(RedirectMatcher), _a.to = typeof to === 'function' ? to : function () {
    return to;
  }, _a.meta = typeof meta === 'function' ? meta : function () {
    return meta;
  }, _a;
}